import styled from "styled-components";

export const SHnumber = styled.h2`
    font-size: 14px;
    font-weight: 300;
    text-transform: none;
    letter-spacing: 0.05em;
`